import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err, fallback = "Algo deu errado. Tente novamente.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const brl = (v) =>
  (v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const UNITS = {
  studios: "NX Studios",
  marketing: "NX Marketing",
  iatech: "NX IA-Tech",
};

export const STAGES = [
  { id: "prospeccao", label: "Prospecção" },
  { id: "qualificacao", label: "Qualificação" },
  { id: "proposta", label: "Proposta" },
  { id: "negociacao", label: "Negociação" },
  { id: "ganho", label: "Ganho" },
  { id: "perdido", label: "Perdido" },
];

export const MONTHS_PT = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

export const monthLabel = (key) => {
  const [y, m] = key.split("-");
  return `${MONTHS_PT[parseInt(m, 10) - 1]}/${y.slice(2)}`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};

export const downloadCsv = async (path, filename) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const PROJECT_STATUSES = [
  { id: "planejamento", label: "Planejamento" },
  { id: "andamento", label: "Em Andamento" },
  { id: "revisao", label: "Em Revisão" },
  { id: "entregue", label: "Entregue" },
];

export const WHATSAPP_URL =
  "https://wa.me/5562983319159?text=" +
  encodeURIComponent("Olá! Gostaria de saber mais sobre os serviços da NX COMPANY.");

export const waLink = (phone) =>
  `https://wa.me/${(phone || "").replace(/\D/g, "")}`;

export const ATEND_STATUSES = [
  { id: "novo", label: "Novo" },
  { id: "em_atendimento", label: "Em atendimento" },
  { id: "aguardando", label: "Aguardando resposta" },
  { id: "convertido", label: "Convertido" },
  { id: "encerrado", label: "Encerrado" },
];

export const ORIGINS = [
  { id: "whatsapp", label: "WhatsApp" },
  { id: "site", label: "Site" },
  { id: "instagram", label: "Instagram" },
  { id: "indicacao", label: "Indicação" },
  { id: "outro", label: "Outro" },
];
